import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
        "cookiesAccepted",
        "user",
        "isUserLoggedIn",
        "token",
        "campaign"
      ]
    })
  ],
  strict: true,
  state: {
    cookiesAccepted: false,
    user: null,
    isUserLoggedIn: false,
    token: null,
    campaign: null
  },
  getters: {
    userId: state => {
      if (state.user === null) {
        return null;
      }

      return state.user.id;
    },
    userName: state => {
      if (state.user === null) {
        return null;
      }

      return state.user.name;
    },
    campaignTitle: state => {
      if (state.campaign === null) {
        return null;
      }

      return state.campaign.title;
    },
    campaignProsperity: state => {
      if (state.campaign === null) {
        return null;
      }

      return state.campaign.prosperity;
    },
    canAdmin: state => {
      if (state.user.type === null) {
        return false;
      }

      return state.user.type >= 30;
    },
    canModerator: state => {
      if (state.user.type === null) {
        return false;
      }

      return state.user.type >= 20;
    },
    canUser: state => {
      if (state.user.type === null) {
        return false;
      }

      return state.user.type >= 10;
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      state.isUserLoggedIn = !!token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setCookiesAccepted(state) {
      state.cookiesAccepted = true;
    },
    setCampaign(state, campaign) {
      state.campaign = campaign;
    }
  },
  actions: {
    setToken({commit}, token) {
      commit("setToken", token);
    },
    setUser({commit}, user) {
      commit("setUser", user);
    },
    setCookiesAccepted({commit}) {
      commit("setCookiesAccepted");
    },
    setCampaign({commit}, campaign) {
      commit("setCampaign", campaign);
    },
    clearUser({commit}) {
      commit("setToken", null);
      commit("setUser", null);
      commit("setCampaign", null);
    }
  }
});
